import { useEffect } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
// Material Dashboard 2 React context
import ScrollToTopButton from "components/ScrollToTopButton";
import { setLayout, useMaterialUIController } from "context";

function PageDefaultLayout({ background = "white", children }) {
  const [, dispatch] = useMaterialUIController();
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "anotherPage");
  }, [pathname]);

  return (
    <MDBox
      width="100%"
      height="100%"
      minHeight="91vh"
      bgColor={background}
      sx={{ overflowX: "hidden", display: "flex", flexDirection: "column" }}
    >
      {children}
      <ScrollToTopButton />
    </MDBox>
  );
}

// Typechecking props for the PageDefaultLayout
PageDefaultLayout.propTypes = {
  background: PropTypes.oneOf(["white", "light", "default"]),
  children: PropTypes.node.isRequired,
};

export default PageDefaultLayout;
